import { render, staticRenderFns } from "./ViewClientsTPA.vue?vue&type=template&id=667100e9&"
import script from "./ViewClientsTPA.vue?vue&type=script&lang=js&"
export * from "./ViewClientsTPA.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports